import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import { IAuth } from '@/modules/auth/types';
import { Button } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';

import Arrow from '~/images/shared/arrow-up.svg';

const StepsActionsContainer: React.FC<{
  step: IAuth.ISubStepSchema;
  stepsCount: number;
}> = ({ step, stepsCount }) => {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const {
    backAction,
    forwardActionhandler,
    idx,
    fields,
    isDisabled = false,
  } = step;
  const { getFieldState, trigger } = useFormContext();

  const hasErrors = fields.some((field) => !!getFieldState(field).error);

  return (
    <div className='flex w-full items-center justify-between'>
      {backAction}
      <Button
        className='flex !w-fit items-center gap-1 !px-16 !py-2'
        size='sm'
        onClick={async (e) => {
          e.preventDefault();
          const isValid = await trigger(fields);
          if (!hasErrors && isValid) forwardActionhandler();
          trackMixpanelEvent(step.trackingTitle, user);
        }}
        disabled={hasErrors || isDisabled}
      >
        <>
          {t(idx === 0 || idx === stepsCount ? 'get-started' : 'next')}
          {idx === 1 || idx === 2 ? (
            <Arrow className='text-14 text-white ltr:rotate-90 rtl:-rotate-90' />
          ) : (
            ''
          )}
        </>
      </Button>
    </div>
  );
};

export { StepsActionsContainer };
